export const environment = {
  production: false,
  envType: 'DEVELOPMENT',
  isFullOnline: true,
  caisseApiUrl: 'https://devgestion.quiditmiam.fr/api',
  title: 'Caisse Collective - Développement',
  buildDate: "2026-10-09T10:15:57",
  lastPipeline: "6748",
  version: "0.0.0",
  sentryDsn: '',
};
